import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

import Sticker from 'design-system/components/Sticker';

const NODE_SIZE = 162;

const stickerCSS = css<{ selected?: boolean; isActive?: boolean }>`
  background-color: ${({ theme }) => theme.color.primary.white};
  color: ${({ theme }) => theme.colorPrimary};
  ${(props) =>
    props.selected &&
    css`
      background-color: ${({ theme }) => theme.color.primary.brand600};
      color: ${({ theme }) => theme.color.variants.basic.default};
    `}
  ${(props) =>
    !props.selected &&
    props.isActive &&
    css`
      background-color: ${({ theme }) => theme.color.primary.brand200};
      color: ${({ theme }) => theme.color.primary.brand600};
    `}
`;

type StyledStickerProps = {
  selected?: boolean;
  isActive?: boolean;
};

const StyledSticker = styled(Sticker)<StyledStickerProps>`
  max-width: ${NODE_SIZE}px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 0px 2px;

  ${stickerCSS}
`;

const ParenthesisContentSticker = styled(Sticker)<StyledStickerProps>`
  ${stickerCSS}
  position: relative;
  left: -6px;
`;

const StickerWrapper = styled.div`
  display: flex;
`;

const NodeSticker = ({
  title,
  selected,
  isActive,
  parenthesesContent,
}: {
  title: string | ReactNode;
  selected?: boolean;
  isActive?: boolean;
  parenthesesContent?: string;
}) => {
  const hasParenthesesContent = parenthesesContent != null;

  return (
    <StickerWrapper>
      <StyledSticker selected={selected} isActive={isActive}>
        {title}
      </StyledSticker>
      {hasParenthesesContent && (
        <ParenthesisContentSticker selected={selected} isActive={isActive}>
          {`(${parenthesesContent})`}
        </ParenthesisContentSticker>
      )}
    </StickerWrapper>
  );
};

export default NodeSticker;
